import { Pipe, PipeTransform } from '@angular/core';
import { ContextMenuItem, DisplayColour } from '@shared/components/menu/context-menu-item';

export interface TaskContextMenuComponent {
  confirmCompleteTask(taskId: string): void;
  editTask(taskId: string): void;
  confirmDeleteTask(taskId: string): void;
}

@Pipe({
  name: 'taskContextMenu'
})
export class TaskContextMenuPipe implements PipeTransform {

  transform(taskId: string, component: TaskContextMenuComponent): ContextMenuItem[] {
    return [
      new ContextMenuItem('Complete', () => {
        component.confirmCompleteTask(taskId);
      }),
      new ContextMenuItem('Edit', () => {
        component.editTask(taskId);
      }),
      new ContextMenuItem(
        'Delete',
        () => {
          component.confirmDeleteTask(taskId);
        },
        DisplayColour.Warning
      )
    ];
  }
}
